import React          from 'react';
import * as PropTypes from 'prop-types';
import classNames     from 'classnames';

import * as func from '../utils/func';

const RangeSliderLegend = (props) => {
  const {
          showLegend,
          fromTo,
          showRuler,
          data,
          value,
          minValue,
          maxValue,
          onChange,
          showCurrency,
          currency,
        } = props;

  const handleClick = (event, value) => {
    event.preventDefault();
    event.stopPropagation();

    onChange(value);
  };

  return (
    <>
      {showLegend && (
        <div className="legend">
          {showRuler && data.map((num, i) => (
            <span
              key={i}
              className={classNames({ 'current': value.min === num || value.max === num })}
              onClick={(event) => handleClick(event, num)}
              style={{ left: `${func.getPercentageFromValue(num, minValue, maxValue) * 100}%` }}
            >{num}</span>
          ))}
          {fromTo && (
            <>
            <span
              className={'from'}
              onClick={(event) => handleClick(event, minValue)}
              style={{ left: `0%` }}
            >
              {value.min}
              {showCurrency && (<span className={'currency'}>{currency}</span>)}
            </span>
              <span
                className={'to'}
                onClick={(event) => handleClick(event, maxValue)}
                style={{ left: `100%` }}
              >
              {value.max}
                {showCurrency && (<span className={'currency'}>{currency}</span>)}
            </span>
            </>
          )}
        </div>
      )}
    </>
  );
};

RangeSliderLegend.defaultProps = {
  showLegend: true,
  fromTo:     false,
  showRuler:  false,
};

RangeSliderLegend.propTypes = {
  showLegend: PropTypes.bool,
  fromTo:     PropTypes.bool,
  showRuler:  PropTypes.bool,
  data:       PropTypes.array,
  value:      PropTypes.object,
  minValue:   PropTypes.number,
  maxValue:   PropTypes.number,
  onChange:   PropTypes.func,
};

export default RangeSliderLegend;